import { useRef, useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const UsePaymentServiceTripNegotiation = (onSuccessPayment) => {
  const { authFetch } = useAuth();

  const [loadingPayment, setLoadingPayment] = useState(false);
  const [paymentProcessing, setPaymentProcessing] = useState(false);
  const [errorPayment, setErrorPayment] = useState("");
  const [pixData, setPixData] = useState(null);
  const [paymentMessage, setPaymentMessage] = useState("");

  const pollingRef = useRef(null);

  useEffect(() => {
    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
      }
    };
  }, []);

  const fetchPaymentStatusOnce = async (
    serieTripNegotiations,
    paymentMethod,
  ) => {
    const response = await authFetch(
      `${API_URL}/api/trip-negotiations/${serieTripNegotiations}/payment-service/status/`,
      {
        headers: {
          //Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      },
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.detail || "Erro ao consultar pagamento.");
    }

    if (paymentMethod === "pix") {
      if (data.service_payment_pix_qrcode) {
        return {
          qrcode: data.service_payment_pix_qrcode,
          copyPaste: data.service_payment_pix_copy_paste,
          paymentId: data.service_payment_id,
        };
      }
      return null;
    }

    if (paymentMethod === "credit_card") {
      if (data.trip_status === "2") {
        return data;
      }
      return null;
    }

    return null;
  };

  const startPolling = async (serieTripNegotiations, paymentMethod) => {
    setPaymentProcessing(true);

    setPaymentMessage(
      paymentMethod === "pix"
        ? "Gerando QR Code do PIX..."
        : "Processando pagamento no cartão...",
    );

    const startedAt = Date.now();
    const maxWait = 180000;

    while (true) {
      try {
        if (Date.now() - startedAt > maxWait) {
          setPaymentProcessing(false);
          setPaymentMessage("");

          throw new Error("Pagamento demorou mais que o esperado.");
        }

        const result = await fetchPaymentStatusOnce(
          serieTripNegotiations,
          paymentMethod,
        );

        if (result) {
          if (paymentMethod === "pix") {
            setPixData(result);

            setPaymentMessage("QR Code PIX gerado com sucesso.");
          } else {
            setPaymentMessage("Pagamento confirmado com sucesso.");

            sessionStorage.setItem("payment_service", "1");

            onSuccessPayment?.(result);
          }

          setPaymentProcessing(false);

          return result;
        }

        await sleep(2000);
      } catch (err) {
        setPaymentProcessing(false);

        setPaymentMessage("");

        throw err;
      }
    }
  };

  const paymentService = async (negotiation, paymentMethod, payload = {}) => {
    try {
      setLoadingPayment(true);
      setErrorPayment("");
      setPixData(null);
      setPaymentMessage("");

      const serie = negotiation?.state?.item?.serie_trip_negotiations;
      if (!serie) {
        throw new Error("Negociação inválida.");
      }

      const response = await authFetch(
        `${API_URL}/api/trip-negotiations/${serie}/payment-service/`,
        {
          method: "POST",
          headers: {
            //Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            payment_method: paymentMethod,
            ...payload,
          }),
        },
      );

      const data = await response.json();

      if (!response.ok && response.status !== 202) {
        throw new Error(data?.detail || "Erro ao efetuar pagamento.");
      }

      // Não prende a UI no POST.
      setLoadingPayment(false);

      // Acompanhar o processamento em background.
      await startPolling(serie, paymentMethod);
    } catch (err) {
      setErrorPayment(err.message || "Erro inesperado.");
      setLoadingPayment(false);
      setPaymentProcessing(false);
      setPaymentMessage("");
    }
  };

  return {
    loadingPayment,
    paymentProcessing,
    paymentMessage,
    errorPayment,
    pixData,
    paymentService,
  };
};

export default UsePaymentServiceTripNegotiation;
